import { useMemo } from "react";

import {
  type DisplayUnits,
  UNIT_SYMBOLS,
  type UnitSystem,
  unitSystemFor,
} from "~/utils/unitSystem";

import { useOrgs } from "./useOrgs";

/**
 * The current org's unit system and the symbols its pages render. Stable per
 * system, so it can sit in a dependency list.
 */
export const useUnitSystem = (): DisplayUnits & { system: UnitSystem } => {
  const { currentOrg } = useOrgs();
  const system = unitSystemFor(currentOrg);
  return useMemo(() => ({ system, ...UNIT_SYMBOLS[system] }), [system]);
};
